import { createSlice } from "@reduxjs/toolkit";


export const shoppingStepSlice = createSlice({
    name: 'shoppingStep',
    initialState:{},
    reducers: { // change shopping step to manage app navigation
        nextShoppingStep: (currentState, action) => {
            return currentState + 1

        },
        previousShoppingStep: (currentState, action) => {
            return currentState - 1

        },
        
        goToShoppingStep: (currentState, action) => {
            return action.payload

        }
    }
});

